<template>
  <div class="test-div">
    <section class="section">
      <h1 class="title">利用規約</h1>
      <p>この利用規約（以下，「本規約」といいます。）は，@there_you_hide（以下，「運営」といいます。）がこのウェブサイト上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。</p>
    </section>
    <section class="section">
      <h2 class="subtitle">第1条（適用）</h2>
      <p>本規約は，ユーザーと運営との間の本サービスの利用に関わる一切の関係に適用されるものとします</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第2条（利用登録）</h2>
      <p>
        登録希望者が運営の定める方法によって利用登録を申請し，運営がこれを承認することによって，利用登録が完了するものとします。
        運営は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。
      </p>
      <ol type="1">
        <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
        <li>本規約に違反したことがある者からの申請である場合</li>
        <li>その他，運営が利用登録を相当でないと判断した場合</li>
      </ol>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第3条（禁止事項）</h2>
      <p>ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。</p>
      <ol type="1">
        <li>法令または公序良俗に違反する行為</li>
        <li>犯罪行為に関連する行為</li>
        <li>運営のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為</li>
        <li>運営のサービスの運営を妨害するおそれのある行為</li>
        <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
        <li>他のユーザーに成りすます行為</li>
        <li>運営のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為</li>
        <li>その他，運営が不適切と判断する行為</li>
      </ol>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第4条（本サービスの提供の停止等）</h2>
      <p>運営は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
      <ol type="1">
        <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
        <li>地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合</li>
        <li>コンピュータまたは通信回線等が事故により停止した場合</li>
        <li>その他，運営が本サービスの提供が困難と判断した場合</li>
      </ol>
      <p>運営は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第5条（利用制限および登録抹消）</h2>
      <p>運営は，以下の場合には，事前の通知なく，ユーザーに対して，本サービスの全部もしくは一部の利用を制限し，またはユーザーとしての登録を抹消することができるものとします。</p>
      <ol type="1">
        <li>本規約のいずれかの条項に違反した場合</li>
        <li>その他，運営が本サービスの利用を適当でないと判断した場合</li>
      </ol>
      <p>運営は，本条に基づき運営が行った行為によりユーザーに生じた損害について，一切の責任を負いません。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第6条（免責事項）</h2>
      <p>運営は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第7条（サービス内容の変更等）</h2>
      <p>運営は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第8条（利用規約の変更）</h2>
      <p>運営は，必要と判断した場合には，ユーザーに通知することなくいつでも本規約を変更することができるものとします。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第9条（通知または連絡）</h2>
      <p>ユーザーと運営との間の通知または連絡は，運営の定める方法によって行うものとします。</p>
      <hr>
    </section>
    <section class="section">
      <h2 class="subtitle">第10条（準拠法・裁判管轄）</h2>
      <p>
        本規約の解釈にあたっては，日本法を準拠法とします。
        本サービスに関して紛争が生じた場合には，運営の本店所在地を管轄する裁判所を専属的合意管轄とします。
      </p>
      <hr>
    </section>
  </div>
</template>

<script>
export default {
  name: "Terms",
  data: function() {
    return {};
  }
};
</script>

<style>
.test-div {
  flex: 1;
}

.full-width {
  min-width: 100%;
}
</style>
